<template>
  <div>
    <ui-heading tag="h5">
      {{ $t("companyProcedures.selfieSettings.title") }}
    </ui-heading>
    <div v-if="selfieTypes && selfieTypes.length">
      <div v-for="(selfieType, index) in selfieTypes" :key="index">
        <section-item :item-name="translateSelfieType(selfieType)" />
      </div>
    </div>
    <div v-else>-</div>
  </div>
</template>
<script>
import { translateSelfieType } from "./utils";
import SectionItem from "./SectionItem";

export default {
  components: { SectionItem },
  props: {
    selfieTypes: { type: Array, default: null }
  },
  methods: {
    translateSelfieType
  }
};
</script>
